import { render, staticRenderFns } from "./MarketingSmsCreate.vue?vue&type=template&id=efa37cec&scoped=true"
import script from "./MarketingSmsCreate.vue?vue&type=script&lang=js"
export * from "./MarketingSmsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa37cec",
  null
  
)

export default component.exports